import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const timeWordList = [
  "adjust",
  "birth",
  "change",
  "clock",
  "constant",
  "dawn",
  "day",
  "death",
  "decay",
  "dim",
  "echo",
  "fall",
  "finish",
  "grow",
  "history",
  "hour",
  "instant",
  "memory",
  "middle",
  "midnight",
  "minute",
  "month",
  "morning",
  "night",
  "origin",
  "present",
  "process",
  "progress",
  "regular",
  "repeat",
  "rhythm",
  "rust",
  "season",
  "slow",
  "spring",
  "stage",
  "start",
  "step",
  "sudden",
  "summer",
  "time",
  "watch",
  "week",
  "winter",
  "year",
];

export const timeCollection: WordCollection = createCollection(
  "time",
  "Time & Change",
  timeWordList,
  { icon: "clock-outline", isWordlistViewable: true },
);
